var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-editor" },
    [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("whatsapp_business_api.header")) +
            " • " +
            _vm._s(_vm.headerLabel)
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticStyle: { width: "200px", "margin-bottom": "8px" },
          attrs: { disabled: _vm.isProductHeader },
          on: { change: _vm.onFormatChange },
          model: {
            value: _vm.localHeaderFormat,
            callback: function ($$v) {
              _vm.localHeaderFormat = $$v
            },
            expression: "localHeaderFormat",
          },
        },
        [
          !_vm.isProductHeader
            ? _c("a-select-option", { attrs: { value: "NONE" } }, [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.headerNone"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProductHeader && !_vm.isLimitedTimeOffer
            ? _c("a-select-option", { attrs: { value: "TEXT" } }, [
                _vm._v(
                  _vm._s(_vm.$t("whatsapp_business_api.headerTextOption"))
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProductHeader &&
          !_vm.isCallPermission &&
          !_vm.isCouponCodeTemplate
            ? _c("a-select-option", { attrs: { value: "IMAGE" } }, [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.image"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProductHeader &&
          !_vm.isCallPermission &&
          !_vm.isCouponCodeTemplate
            ? _c("a-select-option", { attrs: { value: "VIDEO" } }, [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.video"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProductHeader &&
          !_vm.isCouponCodeTemplate &&
          !_vm.isLimitedTimeOffer &&
          !_vm.isCallPermission
            ? _c("a-select-option", { attrs: { value: "DOCUMENT" } }, [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.headerDocument"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isProductHeader
            ? _c("a-select-option", { attrs: { value: "PRODUCT" } }, [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.headerProduct"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isProductHeader
        ? _c(
            "div",
            { staticClass: "product-header-info" },
            [
              _c("a-icon", { attrs: { type: "info-circle" } }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("whatsapp_business_api.productHeaderAutoSet"))
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.headerFormat === "TEXT"
        ? [
            _c("a-input", {
              attrs: {
                value: _vm.headerText,
                placeholder: _vm.$t(
                  "whatsapp_business_api.headerTextPlaceholder"
                ),
                maxLength: 60,
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:headerText", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "char-count" }, [
              _vm._v(_vm._s((_vm.headerText || "").length) + "/60"),
            ]),
            _vm._v(" "),
            _vm.headerVariables.length
              ? _c(
                  "div",
                  { staticClass: "variables-section" },
                  [
                    _c("div", { staticClass: "variables-header" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.variables"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("whatsapp_business_api.defaultVariableName")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.headerVariables, function (variable, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "variable-row" },
                        [
                          _c("a-input", {
                            attrs: { value: variable.variable, disabled: "" },
                          }),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              value: variable.example,
                              placeholder: _vm.$t(
                                "whatsapp_business_api.example"
                              ),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateHeaderVariableExample(
                                  i,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMediaHeader
        ? _c("div", { staticClass: "media-upload-section" }, [
            _vm.media
              ? _c(
                  "div",
                  { staticClass: "media-preview-box" },
                  [
                    _vm.headerFormat === "IMAGE"
                      ? _c("img", {
                          attrs: {
                            src: _vm.media.data,
                            alt: _vm.$t("whatsapp_business_api.previewAlt"),
                          },
                        })
                      : _vm.headerFormat === "VIDEO"
                      ? _c("video", {
                          attrs: { src: _vm.media.data, controls: "" },
                        })
                      : _c(
                          "div",
                          { staticClass: "document-box" },
                          [
                            _c("a-icon", { attrs: { type: "file-pdf" } }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.media.name))]),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "remove-media-btn",
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("remove-media")
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "delete" } })],
                      1
                    ),
                    _vm._v(" "),
                    _vm.uploading
                      ? _c(
                          "div",
                          { staticClass: "upload-status" },
                          [
                            _c("a-spin", { attrs: { size: "small" } }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.uploadingToMeta"
                                  )
                                ) +
                                "\n            "
                            ),
                          ],
                          1
                        )
                      : _vm.exampleMedia
                      ? _c(
                          "div",
                          { staticClass: "upload-success" },
                          [
                            _c("a-icon", { attrs: { type: "check-circle" } }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.uploadedSuccessfully"
                                  )
                                ) +
                                "\n            "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", { staticClass: "media-upload-box" }, [
                  _c("input", {
                    staticClass: "file-input",
                    attrs: { type: "file", accept: _vm.getMediaAcceptType() },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("file-upload", $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload-content" },
                    [
                      _c("a-icon", {
                        staticClass: "upload-icon",
                        attrs: { type: "cloud-upload" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.dragDropUpload"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload-link" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.orChooseFiles"))
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "media-hint" }, [
              _c("b", [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.mediaHintNote"))),
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("whatsapp_business_api.mediaHintIntro")) +
                  "\n            "
              ),
              _c("ul", [
                _vm.headerFormat === "IMAGE"
                  ? _c("li", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.mediaHintImage"))
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.headerFormat === "VIDEO"
                  ? _c("li", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.mediaHintVideo"))
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.headerFormat === "DOCUMENT"
                  ? _c("li", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.mediaHintDocument")
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }